import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const CardSkeleton = ({cards}) => {

    return Array(cards).fill(0).map((item) => (
        <div className="card-skeleton">
            <div className="left-col">
                <Skeleton width={100} height={100} />
            </div>
            <div className="right-col">
                <Skeleton count={3}/> 
            </div>    
        </div>
    ));
}
export default CardSkeleton